function extractVueFunctions () {
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"frontmatter-markdown"},[_c('h1',[_vm._v("Top level heading")]),_vm._v(" "),_c('p',[_vm._v("And some more text")]),_vm._v(" "),_c('Poll',[_c('h1',[_vm._v("My Poll title")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("Another option")]),_vm._v(" "),_c('li',[_vm._v("test2")])])])],1)}
var staticRenderFns = []

return { render: render, staticRenderFns: staticRenderFns }
}
const vueFunctions = extractVueFunctions()

module.exports = { 
      attributes: {"title":"My Introduction Page"},
    
      vue: {
        component: {
          data: function () {
            return {
              templateRender: null
            }
          },
          render: function (createElement) {
            return this.templateRender ? this.templateRender() : createElement("div", "Rendering");
          },
          created: function () {
            this.templateRender = vueFunctions.render;
            this.$options.staticRenderFns = vueFunctions.staticRenderFns;
          }
        }
      },
     }